import { IconHeader, Divider } from "../../../components";
import { FormTextInput } from "../../../features/auto-form";
import { useTranslate } from "../../../features/translation/hooks/use-translation";

const ContactDetails = ({customerType}) => {
  const { t } = useTranslate();

  return (
    <div className="container">
      <div className="row">
        <div className="col col-12">
          <Divider
            className="horizontal thin primary text-title "
            label={t("form.contactDetails.title")}
          />
        </div>
      </div>
      <div
        className="row"
        style={{
          paddingTop: "var(--space-4)",
          paddingBottom: "var(--space-8)",
        }}
      >
        <div className="col col-12">
          <div
            className="text base"
            style={{ textAlign: "center" }}
            dangerouslySetInnerHTML={{
              __html: t("form.contactDetails.description"),
            }}
          />
        </div>
      </div>
      <div className="row">
      <div className="col col-12">
        <div className="container">
          <div className="row">
            <div className="col col-12">
              <IconHeader
                title={t("form.contactDetails.title")}
                icon="user"
              />
            </div>
          </div>
    
          {customerType !== "private" && (
            <div className="row">
              <div className="col col-12 col-sm-6 col-md-4">
                <FormTextInput
                  name="contact.companyName"
                  languagesection="form.contactDetails.companyName"
                  minLength={2}
                  required
                />
              </div>
            </div>
          )}
    
          <div className="row">
            <div className="col col-12 col-sm-6 col-md-4">
              <FormTextInput
                name="contact.fullName"
                languagesection={
                  customerType === "private"
                    ? "form.contactDetails.fullName"
                    : "form.contactDetails.contactName"
                }
                required
              />
            </div>
    
            {customerType !== "private" && (
              <div className="col col-12 col-sm-6 col-md-4">
                <FormTextInput
                  name="contact.title"
                  languagesection="form.contactDetails.roleTitle"
                  required
                />
              </div>
            )}
          </div>
    
          <div className="row">
            <div className="col col-12 col-sm-6 col-md-4">
              <FormTextInput
                name="contact.telephone"
                languagesection="form.contactDetails.telephone"
                type="tel"
                required
              />
            </div>
            <div className="col col-12 col-sm-6 col-md-4">
              <FormTextInput
                name="contact.email"
                languagesection="form.contactDetails.email"
                type="email"
                autoComplete="email"
                required
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    
    </div>
  );
};

export default ContactDetails;
